export default __webpack_public_path__ + "1be5a67d9b736f27ff0f524930c6d1e9.png";